module.exports = __webpack_public_path__ + "static/media/Appakara5.99cb3c80.jpg";